var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonBaile2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sal\\xF3n_de_baile",
    "data-name": "Sal\\xF3n de baile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.545,
    height: 56.547,
    viewBox: "0 0 56.545 56.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M112.167,59.28a1.106,1.106,0,0,0-1.54.261l-.023.032a1.106,1.106,0,0,0,.27,1.534,1.094,1.094,0,0,0,.636.2,1.109,1.109,0,0,0,.9-.463l.021-.032A1.109,1.109,0,0,0,112.167,59.28Z",
    transform: "translate(-78.025 -41.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M89.626,69.469a1.106,1.106,0,0,0-1.554-.153,13.681,13.681,0,0,1-5.182,2.663,1.106,1.106,0,0,0,.293,2.173,1.056,1.056,0,0,0,.293-.038,15.913,15.913,0,0,0,6.015-3.091,1.106,1.106,0,0,0,.135-1.554Z",
    transform: "translate(-58 -48.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M53.229,39.141a3.317,3.317,0,0,0-3.314,3.314v.551a9.4,9.4,0,0,1-7.789,9.25,5.279,5.279,0,0,0,.915-2.98v-.768a5.326,5.326,0,0,0-10.649,0v.768a5.3,5.3,0,0,0,.88,2.912,9.4,9.4,0,0,1-7.446-9.183v-.551a3.314,3.314,0,1,0-6.625,0v.551a15.884,15.884,0,0,0,1.326,6.414h-7.5V38.3a1.106,1.106,0,0,0-.8-1.062A13.866,13.866,0,0,1,2.2,23.958v-.551a1.106,1.106,0,0,1,2.208,0v.551a11.608,11.608,0,0,0,11.6,11.6h5.317a11.608,11.608,0,0,0,11.6-11.6v-.551a1.106,1.106,0,0,1,2.208,0v.551a13.755,13.755,0,0,1-.909,4.93,1.106,1.106,0,0,0,2.053.792,15.907,15.907,0,0,0,1.056-5.722v-.551a3.314,3.314,0,0,0-6.628,0v.551a9.385,9.385,0,0,1-7.781,9.25,5.279,5.279,0,0,0,.915-2.98V29.46a5.323,5.323,0,1,0-10.646,0v.768a5.279,5.279,0,0,0,.88,2.915,9.4,9.4,0,0,1-7.449-9.185v-.551a3.314,3.314,0,1,0-6.625,0v.551a15.863,15.863,0,0,0,3.3,9.725,16.186,16.186,0,0,0,7.52,5.423V50.523a1.1,1.1,0,0,0,1.1,1.106h.2V69.56a1.106,1.106,0,0,0,2.208,0V51.629h7.4q.361.563.774,1.1c.073.1.147.188.223.293V69.56a1.106,1.106,0,0,0,2.205,0V55.268a16.151,16.151,0,0,0,5.085,2.886V69.56a1.106,1.106,0,0,0,2.208,0V57.345a1.1,1.1,0,0,0-.8-1.062A13.869,13.869,0,0,1,21.406,43.006v-.551a1.106,1.106,0,1,1,2.208,0v.551a11.611,11.611,0,0,0,11.6,11.6h5.314a11.611,11.611,0,0,0,11.6-11.6v-.551a1.106,1.106,0,1,1,2.208,0v.551A13.826,13.826,0,0,1,44.085,56.363a1.106,1.106,0,0,0-.819,1.067v7.995a1.106,1.106,0,1,0,2.208,0V58.239A16.039,16.039,0,0,0,56.54,43.006v-.551A3.317,3.317,0,0,0,53.229,39.141ZM15.4,29.463a3.115,3.115,0,1,1,6.229,0v.768a3.115,3.115,0,0,1-6.229,0ZM40.829,49.279a3.118,3.118,0,0,1-6.232,0v-.768a3.118,3.118,0,0,1,6.232,0Z",
    transform: "translate(0.005 -14.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M149.448,185.6a1.106,1.106,0,1,0,.323.78A1.106,1.106,0,0,0,149.448,185.6Z",
    transform: "translate(-104.282 -130.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M60.476,140.84a1.1,1.1,0,0,0-1.106,1.1v13.022a1.106,1.106,0,0,0,2.208,0V141.943A1.1,1.1,0,0,0,60.476,140.84Z",
    transform: "translate(-41.957 -99.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M172.823,30.88a1.1,1.1,0,0,0-1.1,1.1v1.375a1.106,1.106,0,0,0,2.208,0V31.983A1.106,1.106,0,0,0,172.823,30.88Z",
    transform: "translate(-121.357 -21.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M172.823,53.31a1.1,1.1,0,0,0-1.1,1.106v1.373a1.106,1.106,0,0,0,2.208,0V54.416A1.106,1.106,0,0,0,172.823,53.31Z",
    transform: "translate(-121.357 -37.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M182.891,44.436h-1.373a1.106,1.106,0,1,0,0,2.208h1.373a1.106,1.106,0,0,0,0-2.208Z",
    transform: "translate(-127.46 -31.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M160.5,44.436h-1.373a1.106,1.106,0,1,0,0,2.208H160.5a1.106,1.106,0,0,0,0-2.208Z",
    transform: "translate(-111.637 -31.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M80.114,0A1.106,1.106,0,0,0,79,1.106V2.478a1.106,1.106,0,0,0,2.208,0V1.106A1.1,1.1,0,0,0,80.114,0Z",
    transform: "translate(-55.83 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M80.114,22.43A1.106,1.106,0,0,0,79,23.536v1.373a1.106,1.106,0,0,0,2.208,0V23.536A1.1,1.1,0,0,0,80.114,22.43Z",
    transform: "translate(-55.83 -15.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M90.515,13.556H89.143a1.106,1.106,0,0,0,0,2.208h1.373a1.106,1.106,0,1,0,0-2.208Z",
    transform: "translate(-62.257 -9.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M68.085,13.556H66.713a1.106,1.106,0,0,0,0,2.208h1.373a1.106,1.106,0,1,0,0-2.208Z",
    transform: "translate(-46.405 -9.58)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonBaile2);
export default __webpack_public_path__ + "static/media/SalonBaile2.f5203dc051647d3de298aa734bf82d02.svg";
export { ForwardRef as ReactComponent };